<a
    class="relative w-10 h-10 rounded-full overflow-hidden"
    routerLink="/profile"
    routerLinkActive
    #link="routerLinkActive"
    pTooltip="My Profile"
    tooltipPosition="right"
    tooltipStyleClass="p-tooltip-fm-navigation">
    <img
        [src]="(userService.currentUser | async).photo || 'assets/images/blank_profile.png'"
        alt="Profile Picture"
        class="w-full h-full rounded-full object-cover border-2 border-transparent hover:border-blurple"
        [ngClass]="{ '!border-[3px] !border-blurple-dark': link.isActive }" />
</a>
